<script>
import { dispatch, sync } from 'vuex-pathify';
import draggable from 'vuedraggable';
import Field from '@/modules/document/_component/Field';
import Card from '@/components/Card.vue';
import Section from '@/modules/document/_component/values/Section.vue';

export default {
    components: {
        Card,
        Field,
        draggable,
        Section,
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            title: this.section.title,
        };
    },
    computed: {
        ...sync('document', [
            'dragging',
            'view',
        ]),
        sortedFields: {
            get() {
                return this.section.fields;
            },
            set(fields) {
                dispatch('document/updateFieldsOrder', fields.map(field => field.id));
            },
        },
    },
    methods: {
        showAddFieldModal() {
            dispatch('document/setField', {
                section_id: this.section.id,
                options: {
                    width: 12,
                },
            });
            dispatch('document/setShowFieldModal', true);
        },
        showEditSectionModal() {
            dispatch('document/setSection', this.section);
            dispatch('document/setShowSectionModal', true);
        },
        showDeleteSectionModal() {
            dispatch('document/setSection', this.section);
            dispatch('document/setShowDeleteSectionModal', true);
        },
    },
};
</script>

<template>
    <component
        :is="view === 'preview' ? 'Section' : 'Card'"
        class="document-section"
    >
        <template #title>
            {{ section.title || `Section ${section.id}` }}
        </template>
        <template
            v-if="view === 'edit'"
            #actions
        >
            <b-button
                type="button"
                size="xs"
                @click="showEditSectionModal"
            >
                <i class="fa fa-fw fa-pencil" /> Edit section
            </b-button>
            <b-button
                type="button"
                size="xs"
                variant="outline-danger"
                @click="showDeleteSectionModal"
            >
                <i class="fa fa-fw fa-trash" /> Delete section
            </b-button>
        </template>
        <template v-if="!dragging">
            <draggable
                v-model="sortedFields"
                class="row"
            >
                <Field
                    v-for="field in section.fields"
                    :key="field.id"
                    :field="field"
                />
            </draggable>

            <b-button
                v-if="view === 'edit'"
                type="button"
                size="xs"
                variant="outline-primary"
                @click="showAddFieldModal"
            >
                <i class="fa fa-fw fa-plus" /> Add field
            </b-button>
        </template>
    </component>
</template>
